import { useState, useEffect } from 'react';
import ExchangeHistoryService from '../../../services/exchangeHistory_service';
import ExchangeProductService from '../../../services/exchangeProduct_service';

const User = (vm) => {
  const [currentUser, setCurrentUser] = useState(vm.user);
  const [score, setScore] = useState(0);
  const [prizes, setPrizes] = useState([]);
  const [exchanges, setExchanges] = useState([]);

  const syncUser = (updatedUser) => {
    setCurrentUser(updatedUser);
    vm.setUser(updatedUser);
    setScore((prev) => prev + 1);
  };

  useEffect(() => {
    (async () => {
      try {
        const [products, history] = await Promise.all([
          ExchangeProductService.getAll(),
          ExchangeHistoryService.getAll(),
        ]);
        if (vm.logout?.(products) || vm.logout?.(history)) return;
        setPrizes(products || []);
        setExchanges(history || []);
      } catch (e) {
        vm.message?.(e?.message || e, 'error');
      }
    })();
  }, []);

  return {
    score,
    prizes,
    exchanges,
    currentUser,
    syncUser
  };
};

export default User;
